import React from "react";
import { CssBaseline, StyledEngineProvider, ThemeProvider } from "@mui/material";
import { Provider } from 'react-redux';
import theme from "./theme";
import Routes from "./Routes";
import store from "./store";
import LoadApp from './containers/LoadApp'
import AlertsContainer from "./containers/AlertsContainer";

function App() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Provider store={store}>
          <LoadApp>
            <Routes />
            <AlertsContainer />
          </LoadApp>
        </Provider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

export default App;
